
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 448 512","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 16C0 7.2 7.2 0 16 0h416c8.8 0 16 7.2 16 16s-7.2 16-16 16H16C7.2 32 0 24.8 0 16zm64 180.8c5-1.6 10.2-3.2 15.4-4.6C121 181.2 174.5 176 224 176s103 5.2 144.6 16.3c5.3 1.4 10.4 2.9 15.4 4.6V64h32v146.6c2.1 1.2 4.2 2.5 6.1 3.8 13.9 9.4 25.9 23 25.9 41.6 0 69.8-35.8 118.1-81 148.5l15.2 51c1.2 4.1 1.8 8.3 1.8 12.5 0 24.3-19.7 43.9-43.9 43.9H107.9C83.7 512 64 492.3 64 468.1c0-4.2.6-8.5 1.8-12.5l15.2-51C35.8 374.1 0 325.8 0 256c0-18.5 12-32.2 25.9-41.6 1.9-1.3 4-2.6 6.1-3.8V64h32zM40.3 305.7c11.3 31.6 33.2 55.4 59.7 72.9 39.4 26.1 88.2 37.4 124 37.4s84.6-11.3 124.1-37.3c26.5-17.5 48.4-41.3 59.7-72.9-11.5 5.6-24.9 10.2-39.2 14C327 330.8 273.5 336 224 336s-103-5.2-144.6-16.3c-14.3-3.8-27.6-8.4-39.2-14zM416 256c0-3.1-1.8-8.3-11.8-15-9.8-6.6-24.7-12.7-43.9-17.8C322.2 213.1 271.7 208 224 208s-98.2 5.1-136.3 15.2c-19.2 5.1-34.1 11.2-43.9 17.8-10 6.7-11.8 11.9-11.8 15s1.8 8.3 11.8 15c9.8 6.6 24.7 12.7 43.9 17.8C125.8 298.9 176.3 304 224 304s98.2-5.1 136.3-15.2c19.2-5.1 34.1-11.2 43.9-17.8 9.9-6.7 11.8-11.9 11.8-15zM112 64h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16s7.2-16 16-16zm239.5 400.7l-13.1-43.8C299.6 439.7 257.3 448 224 448s-75.6-8.3-114.4-27.2l-13.1 43.9c-.3 1.1-.5 2.3-.5 3.4 0 6.6 5.3 11.9 11.9 11.9h232.2c6.6 0 11.9-5.3 11.9-11.9 0-1.2-.2-2.3-.5-3.4z"}})])
          )
        }
      }
    